import { Link } from "react-router-dom";
import { useEffect } from "react";
import { MapPin, PlayCircle, MonitorSmartphone, LayoutDashboard, ArrowRight } from "lucide-react";
import { track } from "@/lib/track";

const BANNER = "https://customer-assets-gfyr7b9c.emergentagent.net/job_checkpoint-monitor/artifacts/p2bxbg7t_image.png";

const options = [
  { to: "/widget?ssg=true", icon: MapPin, title: "LiveAnzeige Wiesbaden", desc: "Echtzeit-Status der Terrorsperre am Marktplatz", accent: "live" },
  { to: "/widget?simulate=true&ssg=true", icon: PlayCircle, title: "Simulationsanzeige", desc: "Vorführmodus mit simulierten Ein- und Ausfahrten", accent: "sim" },
  { to: "/widget?dual=true&ssg=true", icon: MonitorSmartphone, title: "Tablet/Desktopmodus", desc: "Live & Simulation nebeneinander im Smartphone-Frame", accent: "dual" },
];

export default function Landing() {
  useEffect(() => { track("view_landing"); }, []);
  return (
    <div className="landing" data-testid="landing-page">
      <div className="landing-inner">
        <div className="landing-banner"><img src={BANNER} alt="TERRORSPERREN.DIGITAL" /></div>
        <h1 className="landing-h1">Terrorsperren-Überwachung</h1>
        <p className="landing-sub">Wählen Sie eine Ansicht</p>

        <div className="landing-grid">
          {options.map((o) => {
            const Icon = o.icon;
            return (
              <Link key={o.to} to={o.to} className={`landing-card ${o.accent}`} data-testid={`landing-${o.accent}`}>
                <span className="lc-icon"><Icon size={26} /></span>
                <div className="lc-text">
                  <div className="lc-title">{o.title}</div>
                  <div className="lc-desc">{o.desc}</div>
                </div>
                <ArrowRight className="lc-arrow" size={20} />
              </Link>
            );
          })}
        </div>

        <Link to="/db" className="landing-dash" data-testid="landing-dashboard">
          <LayoutDashboard size={18} /> Dashboard <ArrowRight size={16} />
        </Link>

        <a href="https://sperren-digital.de" target="_blank" rel="noopener noreferrer" className="landing-more" data-testid="landing-more">
          Mehr erfahren auf sperren-digital.de <ArrowRight size={15} />
        </a>
      </div>
    </div>
  );
}
